<template>
    <div>

        <!--Start Middle content-->

        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Meet the HR Team </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->

        <div class="internal-page-main-section col-12">
            <div class="container">
                <div class="row">
                    <template v-for="(text, index) in hrTeamList">
                        <template v-if="index == 0">
                            <template v-if="index+1 == hrTeamList.length">
                                <div class="program-section-main hr-team-detail-main col-12 float-l pb-60" :id="'hr_' + text.id">
                                     <!--first member-->
                                     <div class="row">
                                        <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                            <!--left section-->
                                            <div class="row">
                                                <div class="hover-home-eefect employee-border">
                                                    <img :src="text.profile_image" alt="Elizabeth Lizarraga">
                                                </div>
                                            </div>
                                        </div>
                                        <!--left section-->

                                        <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                            <!--right section-->
                                            <div class="row">
                                                <template v-if="text.last_name != '' || text.first_name != ''">
                                                    <h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"> {{text.first_name}} {{text.last_name}} </h3>
                                                </template>
                                                <template v-if="text.post != '' || text.team_designation != ''">
                                                    <p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> {{text.post}}, {{text.team_designation}} </p>
                                                </template>
                                                <template v-if="text.description != ''">
                                                    <p v-html="text.description" class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"/>
                                                </template>
                                                <template v-if="text.quote != ''">
                                                    <p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ {{text.quote}} ” </p>
                                                </template>
                                                <template v-if="text.quote_name != ''">
                                                    <p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - {{text.quote_name}} </p>
                                                </template>
                                            </div>
                                        </div>
                                        <!--right section-->
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="program-section-main hr-team-detail-main col-12 float-l pb-60 border-bottom-dddddd" :id="'hr_' + text.id">
                                     <!--first member-->
                                     <div class="row">
                                        <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                            <!--left section-->
                                            <div class="row">
                                                <div class="hover-home-eefect employee-border">
                                                    <img :src="text.profile_image" alt="Elizabeth Lizarraga">
                                                </div>
                                            </div>
                                        </div>
                                        <!--left section-->

                                        <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                            <!--right section-->
                                            <div class="row">
                                                <template v-if="text.last_name != '' || text.first_name != ''">
                                                    <h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"> {{text.first_name}} {{text.last_name}} </h3>
                                                </template>
                                                <template v-if="text.post != '' || text.team_designation != ''">
                                                    <p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> {{text.post}}, {{text.team_designation}} </p>
                                                </template>
                                                <template v-if="text.description != ''">
                                                    <p v-html="text.description" class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"/>
                                                </template>
                                                <template v-if="text.quote != ''">
                                                    <p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ {{text.quote}} ” </p>
                                                </template>
                                                <template v-if="text.quote_name != ''">
                                                    <p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - {{text.quote_name}} </p>
                                                </template>
                                            </div>
                                        </div>
                                        <!--right section-->
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="index+1 == hrTeamList.length">
                                <div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60" :id="'hr_' + text.id">
                                     <!--first member-->
                                     <div class="row">
                                        <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                            <!--left section-->
                                            <div class="row">
                                                <div class="hover-home-eefect employee-border">
                                                    <img :src="text.profile_image" alt="Elizabeth Lizarraga">
                                                </div>
                                            </div>
                                        </div>
                                        <!--left section-->

                                        <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                            <!--right section-->
                                            <div class="row">
                                                <template v-if="text.last_name != '' || text.first_name != ''">
                                                    <h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"> {{text.first_name}} {{text.last_name}} </h3>
                                                </template>
                                                <template v-if="text.post != '' || text.team_designation != ''">
                                                    <p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> {{text.post}}, {{text.team_designation}} </p>
                                                </template>
                                                <template v-if="text.description != ''">
                                                    <p v-html="text.description" class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"/>
                                                </template>
                                                <template v-if="text.quote != ''">
                                                    <p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ {{text.quote}} ” </p>
                                                </template>
                                                <template v-if="text.quote_name != ''">
                                                    <p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - {{text.quote_name}} </p>
                                                </template>
                                            </div>
                                        </div>
                                        <!--right section-->
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60 border-bottom-dddddd" :id="'hr_' + text.id">
                                     <!--first member-->
                                     <div class="row">
                                        <div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">
                                            <!--left section-->
                                            <div class="row">
                                                <div class="hover-home-eefect employee-border">
                                                    <img :src="text.profile_image" alt="Elizabeth Lizarraga">
                                                </div>
                                            </div>
                                        </div>
                                        <!--left section-->

                                        <div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">
                                            <!--right section-->
                                            <div class="row">
                                                <template v-if="text.last_name != '' || text.first_name != ''">
                                                    <h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"> {{text.first_name}} {{text.last_name}} </h3>
                                                </template>
                                                <template v-if="text.post != '' || text.team_designation != ''">
                                                    <p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> {{text.post}}, {{text.team_designation}} </p>
                                                </template>
                                                <template v-if="text.description != ''">
                                                    <p v-html="text.description" class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"/>
                                                </template>
                                                <template v-if="text.quote != ''">
                                                    <p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ {{text.quote}} ” </p>
                                                </template>
                                                <template v-if="text.quote_name != ''">
                                                    <p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - {{text.quote_name}} </p>
                                                </template>
                                            </div>
                                        </div>
                                        <!--right section-->
                                    </div>
                                </div>
                            </template>

                        </template>
                    </template>
                    <!--first member-->

                    <!--<div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60 border-bottom-dddddd">-->
                    <!--&lt;!&ndash;second member&ndash;&gt;-->
                    <!--<div class="row">-->

                    <!--<div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<div class="hover-home-eefect employee-border">-->
                    <!--<img src="../../static/images/team-employee-2.jpg" alt="Gordy Evans">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->

                    <!--<div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-5"> Gordy Evans </h3>-->

                    <!--<p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> Director of Human Resources, Arizona </p>-->

                    <!--<p class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"> I have been with VVG since the company acquired Freightliner of Arizona in April of 2015. I moved from Utah in 2005 where I began my career with Freightliner of Arizona. I have always enjoyed working with people. I believe-->
                    <!--it's a recognizable fact that if people are trained properly and in turn are compensated appropriately for the job they do the result is generally a Most Excellent employee. Every day you come to work you have the opportunity-->
                    <!--to turn it into something special. </p>-->

                    <!--<p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ The joy we feel has little to do with the circumstances of our lives and everything to do with the focus of our lives ” </p>-->

                    <!--<p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - Russell M. Nelson </p>-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;second member&ndash;&gt;-->

                    <!--<div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60 border-bottom-dddddd">-->
                    <!--&lt;!&ndash;third member&ndash;&gt;-->
                    <!--<div class="row">-->

                    <!--<div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<div class="hover-home-eefect employee-border">-->
                    <!--<img src="../../static/images/team-employee-6.jpg" alt="Gordy Evans">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->

                    <!--<div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-5"> Cynthia Ortega </h3>-->

                    <!--<p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> Benefits Specialist, Corporate </p>-->

                    <!--<p class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"> I’ve been with VVG since 2014 in various roles, and currently as the Benefits Specialist. I work with employees and vendors alike to assist with any questions or concerns. I am also constantly developing the Dayforce experience-->
                    <!--for employees and managers to evaluate and improve our everyday processes where possible. I believe in seizing opportunities for growth by embracing change and adapting. </p>-->

                    <!--<p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ Only by being open to change will you have a true opportunity to get the most from your talent ” </p>-->

                    <!--<p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - Nolan Ryan </p>-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;third member&ndash;&gt;-->

                    <!--<div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60 border-bottom-dddddd">-->
                    <!--&lt;!&ndash;forth member&ndash;&gt;-->
                    <!--<div class="row">-->

                    <!--<div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<div class="hover-home-eefect employee-border">-->
                    <!--<img src="../../static/images/team-employee-3.jpg" alt="Gordy Evans">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->

                    <!--<div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-5"> Isamar Montano </h3>-->

                    <!--<p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> Onboarding Coordinator, Corporate </p>-->

                    <!--<p class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"> My name is Isamar Montano (Is-Uh-Mar) and I’m the Onboarding Coordinator for Velocity Vehicle Group. I have been with VVG for 1 year and 3 months and I’ve enjoyed every minute of it! My primary functions are to assist hiring-->
                    <!--managers with new hires and to ensure that each new hire feels “on-board”. Please reach out to me if you have any suggestions on how to improve our new hire experience! </p>-->

                    <!--<p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ We can’t help everyone, but everyone can help someone. ” </p>-->

                    <!--<p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - John Lennon </p>-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;forth member&ndash;&gt;-->

                    <!--<div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60 border-bottom-dddddd">-->
                    <!--&lt;!&ndash;fifth member&ndash;&gt;-->
                    <!--<div class="row">-->

                    <!--<div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<div class="hover-home-eefect employee-border">-->
                    <!--<img src="../../static/images/team-employee-4.jpg" alt="Lexi Santana">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->

                    <!--<div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-5"> Lexi Santana </h3>-->

                    <!--<p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> HR Assistant, Corporate </p>-->

                    <!--<p class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"> Hello, I’m the HR Assistant for Velocity Vehicle Group and I’ve been with the company for 6 Months. I assist Cynthia with Benefits and work with Isamar to welcome all our new employees at New Hire Orientation. VVG is a-->
                    <!--great company to work for and I’m excited for what the future holds! </p>-->

                    <!--<p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ You miss 100 percent of the shots you never take. ” </p>-->

                    <!--<p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - Wayne Gretzky </p>-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;fifth member&ndash;&gt;-->

                    <!--<div class="program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60">-->
                    <!--&lt;!&ndash;sixth member&ndash;&gt;-->
                    <!--<div class="row">-->

                    <!--<div class="program-img-left col-12 col-sm-4 col-md-4 col-lg-4">-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<div class="hover-home-eefect employee-border">-->
                    <!--<img src="../../static/images/team-employee-5.jpg" alt="Lexi Santana">-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;left section&ndash;&gt;-->

                    <!--<div class="program-img-right col-12 col-sm-8 col-md-8 col-lg-8">-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->
                    <!--<div class="row">-->
                    <!--<h3 class="team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-5"> Jazmin Perez </h3>-->

                    <!--<p class="employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"> HR Assistant, Corporate </p>-->

                    <!--<p class="employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45"> Hi, I’m the HR Assistant for Velocity Vehicle Group I am new to the company. I was recently hired and I’ve been working with the company for 1 month. I help Isamar with Onboarding and help managers look for new employees.-->
                    <!--I am very enthusiastic to have joined a great company like VVG. </p>-->

                    <!--<p class="employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"> “ Good, better, best. Never let it rest. ‘Till your good is better and your better is best. ” </p>-->

                    <!--<p class="des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"> - St. Jerome </p>-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;right section&ndash;&gt;-->

                    <!--</div>-->
                    <!--</div>-->
                    <!--sixth member-->

                </div>
            </div>
        </div>


        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import axios from 'axios';

    var self;
    export default {
        name: 'Meet_HR_Team',
        props: [''],
        mixins: [SessioMixin],
        data() {
            return {
                jumpToHr: '',
                hrTeamList: [],
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getHRTeam();
            self.getBuildVersion();
//            $(window).scrollTop($('#hr_54').offset().top);
        },

        methods: {
            getHRTeam: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[2]);
                var fields = {id: 0};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('gethrteam', fields, config).
//                HTTP.post('getregisteruser', '', config).
                        then(response => {
                            self.hrTeamList = response.data.content;
                            if (segments[2]) {
                                self.jumpToHr = segments[2];
                                setTimeout(function () {
                                    var top = $("#hr_" + segments[2]).offset().top;
                                    //var left = $("#hr_" + segments[2]).offset().left;
                                    window.scrollTo(0, top);
                                }, 10);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/MeetHRTeam.vue